var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { getRoleName } from "../../auth/CaseRoles";
export class RolesService extends BaseRemoteService {
    getAll(caseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/roles/`;
            const items = yield this.getRequest(url);
            return items.map(item => this.attachRoleName(item));
        });
    }
    getUserActiveRoles(caseId) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/roles/active`;
            const items = yield _super.getRequest.call(this, url);
            return items.map(item => this.attachRoleName(
            // take our raw string array and form it back to an object so we can return code and friendly name
            { roleType: item }));
        });
    }
    createRole(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/roles/`;
            yield this.postRequest(url, model);
        });
    }
    removeRole(caseId, roleId) {
        const _super = Object.create(null, {
            deleteRequest: { get: () => super.deleteRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/roles/${roleId}`;
            yield _super.deleteRequest.call(this, url);
        });
    }
    attachRoleName(model) {
        return Object.assign(Object.assign({}, model), { roleTypeName: getRoleName(model.roleType) });
    }
}
